<template>
  <v-dialog v-model="visible" width="60rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon icon="ld" class="mr-2" :strokewidth="3" fill="white" />
          <v-toolbar-title class="ml-1">
            Lični dohodak
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-h5 mr-4">{{ $n(item.neto_total) }} KM</div>
          <v-toolbar-items v-if="item.id > 0">
            <v-tooltip top color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="print(false)" v-bind="attrs" v-on="on">
                  <sabira_icon icon="file-pdf" fill="white" />
                </v-btn>
              </template>
              <span>LD pdf</span>
            </v-tooltip>
            <v-tooltip top color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="show_email = true" v-bind="attrs" v-on="on">
                  <sabira_icon icon="email_invoice" fill="white" />
                </v-btn>
              </template>
              <span>Pošalji LD</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_delete_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="trash" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Obriši LD</span>
            </v-tooltip>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>LD Kalkulator</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <div class="container">
          <div
            style="padding-left:1rem;padding-top:1.9rem;"
            class="salary_info"
          >
            <div v-if="this.item.neto > 0">
              UKUPNA ISPLATA UPOSLENIKU
              {{ $n(parseFloat(this.item.neto_total).toFixed(2)) }}
              KM
              <v-divider></v-divider>
            </div>
            <br />
            <div v-if="this.item.neto > 0">
              Lični odbitak (sa poreske kartice)
              {{ $n(parseFloat(this.item.personal_deduction).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Neto LD
              {{ $n(parseFloat(this.item.neto).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Neto LD prije oporezivanja
              {{ $n(parseFloat(this.item.net_without_tax).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Porez na dohodak
              {{ $n(parseFloat(this.item.salary_tax).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Bruto LD
              {{ $n(parseFloat(this.item.bruto).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <br />
            <div v-if="this.item.neto > 0">
              Doprinos za penzijsko i invalidsko osiguranje
              {{ $n(parseFloat(this.item.pen_dis_insu).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinos za zdravstveno osiguranje
              {{ $n(parseFloat(this.item.health_insu).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinos za osiguranje od nezaposlenosti
              {{ $n(parseFloat(this.item.unemp_insu).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinosi iz bruto plate (na teret uposlenika)
              {{ $n(parseFloat(this.item.salary_contribution).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <br />
            <div v-if="this.item.neto > 0">
              Doprinos za penzijsko i invalidsko osiguranje
              {{ $n(parseFloat(this.item.pen_dis_insu_emplr).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinos za zdravstveno osiguranje
              {{ $n(parseFloat(this.item.health_insu_emplr).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinos za osiguranje od nezaposlenosti
              {{ $n(parseFloat(this.item.unemp_insu_emplr).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Doprinosi iz bruto plate (na teret poslodavca)
              {{ $n(parseFloat(this.item.contribution_to_salary).toFixed(2)) }}
              KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Ukupni trošak za poslodavca
              {{ $n(parseFloat(this.item.total_cost_emplr).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <br />
            <div v-if="this.item.neto > 0">
              Naknada vodna
              {{ $n(parseFloat(this.item.water_contribution).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Naknada za zaštitu od nesreća
              {{ $n(parseFloat(this.item.disaster_contribution).toFixed(2)) }}
              KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Naknada za zapošljavanje invalida
              {{ $n(parseFloat(this.item.disabled_contribution).toFixed(2)) }}
              KM
              <v-divider></v-divider>
            </div>
            <div v-if="this.item.neto > 0">
              Ukupni trošak za poslodavca sa naknadama
              {{ $n(parseFloat(this.item.total_cost_emplr_tax).toFixed(2)) }} KM
              <v-divider></v-divider>
            </div>
            <br />
          </div>
          <div style="margin-bottom:0px;" class="salary_info">
            <v-card-text class="mr-0 mb-0 mt-0 pt-2 pr-0">
              <div>
                <div>
                  <v-tabs-items v-model="active_tab">
                    <v-tab-item>
                      <v-list class="pa-0 ma-0">
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mb-3">
                            <webpage_lookup_employees_salary
                              update="wp_employee_changed_salary"
                              :selected_id="item.employee_id"
                            ></webpage_lookup_employees_salary>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mb-0 pb-0">
                            <v-select
                              class="select"
                              mandatory
                              :items="months"
                              outlined
                              label="Mjesec"
                              v-model="item.salary_month"
                            />
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                            <v-select
                              class="select"
                              mandatory
                              :items="years"
                              outlined
                              label="Godina"
                              v-model="item.salary_year"
                            />
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                            <v-text-field
                              v-model.number="item.neto"
                              outlined
                              label="Neto iznos ličnog dohodka"
                              required
                              type="number"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                            <v-text-field
                              v-model.number="item.meals"
                              outlined
                              label="Iznos toplog obroka"
                              required
                              type="number"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                            <v-text-field
                              v-model.number="item.transportation"
                              outlined
                              label="Iznos naknade za prevoz"
                              required
                              type="number"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                            <v-text-field
                              v-model.number="item.salary_bonus_other"
                              outlined
                              label="Iznos ostalih naknada"
                              required
                              type="number"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="ml-0 pl-0">
                          <v-list-item-content class="mt-0 pt-1 ">
                            <v-text-field
                              v-model.number="item.personal_deduction"
                              outlined
                              label="Lični odbitak (sa poreske kartice)"
                              required
                              type="number"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-tab-item>
                  </v-tabs-items>
                </div>
              </div>
            </v-card-text>
          </div>
        </div>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="btn_is_loading" text depressed @click="save_salary()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
    <v-dialog width="30rem" persistent scrollable v-model="show_delete_options">
      <v-card>
        <v-card-title class="pb-0 mb-0">Brisanje ličnog dohodka</v-card-title>
        <v-card-text class="pt-0 mt-0">
          <v-list color="transparent">
            <v-list-item>
              <v-list-item-content>
                {{ "Želite obrisati lični dohodak?" }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="show_delete_options = false">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="delete_salary()">Obriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <sabira_email
      :sender="email.sender"
      :message="email.message"
      :subject="email.subject"
      :attachments="email.attachments"
      :recipients="email.recipients"
      :visible="show_email"
      close="close_email_dialog"
    ></sabira_email>
  </v-dialog>
</template>

<script>
var QRCode = require("qrcode");
import jspdf from "jspdf";
import "jspdf-autotable";
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_employees_salary: () =>
      import("@/components/lookups/employees_salary"),
    sabira_email: () => import("@/components/email"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    show_delete_options: false,
    is_loading: true,
    btn_is_loading: false,
    active_tab: 0,
    selected_item: {
      id: null,
    },
    show_email: false,
    logo_width: 0,
    logo_height: 0,
    logo_ratio: 1,
    email: {
      recipients: [
        {
          name: null,
          email: null,
        },
      ],
      sender: {
        name: null,
        email: null,
      },
      subject: null,
      message: null,
      attachments: [],
    },
    selected_month: new Date().getMonth() + 1,
    months: [
      { text: "Januar", value: 1 },
      { text: "Februar", value: 2 },
      { text: "Mart", value: 3 },
      { text: "April", value: 4 },
      { text: "Maj", value: 5 },
      { text: "Juni", value: 6 },
      { text: "Juli", value: 7 },
      { text: "August", value: 8 },
      { text: "Septembar", value: 9 },
      { text: "Oktobar", value: 10 },
      { text: "Novembar", value: 11 },
      { text: "Decembar", value: 12 },
    ],
    selected_year: new Date().getFullYear(),
    years: [
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3,
      new Date().getFullYear() - 4,
      new Date().getFullYear() - 5,
    ],
    item: {
      id: 0,
      neto: null,
      bruto: null,
      salary_created: null,
      employee_id: null,
      salary_year: null,
      salary_month: null,
      personal_deduction: null,
      neto_personal: null,
      salary_contribution: null,
      contribution_to_salary: null,
      net_without_tax: null,
      salary_tax: null,
      water_contribution: null,
      disaster_contribution: null,
      disabled_contribution: null,
      meals: 0,
      transportation: 0,
      salary_bonus_other: 0,
      pen_dis_insu: null,
      health_insu: null,
      unemp_insu: null,
      pen_dis_insu_emplr: null,
      health_insu_emplr: null,
      unemp_insu_emplr: null,
      total_cost_emplr: null,
      total_cost_emplr_tax: null,
      neto_total: 0,
    },
    visible: false,
  }),
  computed: {
    neto_total_calculated() {
      return (
        this.item.neto +
        this.item.meals +
        this.item.transportation +
        this.item.salary_bonus_other
      );
    },
    bruto_calculated() {
      return (this.item.personal_deduction + this.item.neto_personal) / 0.69;
    },
    neto_personal_deduction() {
      return (this.item.neto - this.item.personal_deduction) / 0.9;
    },
    contribution_calculated() {
      return this.item.bruto * 0.31;
    },
    contribution_to() {
      return this.item.bruto * 0.105;
    },
    net_without_tax_calculated() {
      return this.item.bruto - this.item.salary_contribution;
    },
    salary_tax_calculated() {
      return (this.item.net_without_tax - this.item.personal_deduction) * 0.1;
    },
    water_contribution_calculated() {
      return this.item.neto * 0.005;
    },
    disaster_contribution_calculated() {
      return this.item.neto * 0.005;
    },
    disabled_contribution_calculated() {
      return this.item.bruto * 0.005;
    },
    pen_dis_insu_calculated() {
      return this.item.bruto * 0.17;
    },
    health_insu_calculated() {
      return this.item.bruto * 0.125;
    },
    unemp_insu_calculated() {
      return this.item.bruto * 0.015;
    },
    pen_dis_insu_emplr_calculated() {
      return this.item.bruto * 0.06;
    },
    health_insu_emplr_calculated() {
      return this.item.bruto * 0.04;
    },
    unemp_insu_emplr_calculated() {
      return this.item.bruto * 0.005;
    },
    total_cost_emplr_calculated() {
      return Number(
        this.item.bruto +
          this.item.contribution_to_salary +
          this.item.meals +
          this.item.transportation +
          this.item.salary_bonus_other
      );
    },
    total_cost_emplr_tax_calculated() {
      return Number(
        this.item.total_cost_emplr +
          this.item.water_contribution +
          this.item.disaster_contribution +
          this.item.disabled_contribution
      );
    },
  },
  watch: {
    "item.personal_deduction": function(val) {
      if (val === null || val === "") {
        this.item.personal_deduction = 0;
      }
    },
    "item.transportation": function(val) {
      if (val === null || val === "") {
        this.item.transportation = 0;
      }
    },
    "item.meals": function(val) {
      if (val === null || val === "") {
        this.item.meals = 0;
      }
    },
    "item.salary_bonus_other": function(val) {
      if (val === null || val === "") {
        this.item.salary_bonus_other = 0;
      }
    },
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
        } else {
          this.item = {
            id: 0,
            neto: 0,
            bruto: null,
            salary_created: null,
            employee_id: null,
            salary_year: null,
            salary_month: null,
            personal_deduction: 300,
            neto_personal: null,
            salary_contribution: null,
            contribution_to_salary: null,
            net_without_tax: null,
            salary_tax: null,
            water_contribution: null,
            disaster_contribution: null,
            disabled_contribution: null,
            meals: 0,
            transportation: 0,
            salary_bonus_other: 0,
            pen_dis_insu: null,
            health_insu: null,
            unemp_insu: null,
            pen_dis_insu_emplr: null,
            health_insu_emplr: null,
            unemp_insu_emplr: null,
            total_cost_emplr: null,
            total_cost_emplr_tax: null,
            neto_total: 0,
          };
          this.is_loading = false;
        }
      },
      immediate: false,
    },
    bruto_calculated: {
      handler() {
        this.item.bruto = this.bruto_calculated;
      },
      immediate: false,
    },
    neto_personal_deduction: {
      handler() {
        this.item.neto_personal = this.neto_personal_deduction;
      },
      immediate: false,
    },
    contribution_calculated: {
      handler() {
        this.item.salary_contribution = this.contribution_calculated;
      },
      immediate: false,
    },
    contribution_to: {
      handler() {
        this.item.contribution_to_salary = this.contribution_to;
      },
      immediate: false,
    },
    net_without_tax_calculated: {
      handler() {
        this.item.net_without_tax = this.net_without_tax_calculated;
      },
      immediate: false,
    },
    salary_tax_calculated: {
      handler() {
        this.item.salary_tax = this.salary_tax_calculated;
      },
      immediate: false,
    },
    water_contribution_calculated: {
      handler() {
        this.item.water_contribution = this.water_contribution_calculated;
      },
      immediate: false,
    },
    disaster_contribution_calculated: {
      handler() {
        this.item.disaster_contribution = this.disaster_contribution_calculated;
      },
      immediate: false,
    },
    disabled_contribution_calculated: {
      handler() {
        this.item.disabled_contribution = this.disabled_contribution_calculated;
      },
      immediate: false,
    },
    neto_total_calculated: {
      handler() {
        this.item.neto_total = this.neto_total_calculated;
      },
      immediate: false,
    },
    pen_dis_insu_calculated: {
      handler() {
        this.item.pen_dis_insu = this.pen_dis_insu_calculated;
      },
      immediate: false,
    },
    health_insu_calculated: {
      handler() {
        this.item.health_insu = this.health_insu_calculated;
      },
      immediate: false,
    },
    unemp_insu_calculated: {
      handler() {
        this.item.unemp_insu = this.unemp_insu_calculated;
      },
      immediate: false,
    },
    pen_dis_insu_emplr_calculated: {
      handler() {
        this.item.pen_dis_insu_emplr = this.pen_dis_insu_emplr_calculated;
      },
      immediate: false,
    },
    health_insu_emplr_calculated: {
      handler() {
        this.item.health_insu_emplr = this.health_insu_emplr_calculated;
      },
      immediate: false,
    },
    unemp_insu_emplr_calculated: {
      handler() {
        this.item.unemp_insu_emplr = this.unemp_insu_emplr_calculated;
      },
      immediate: false,
    },
    total_cost_emplr_calculated: {
      handler() {
        this.item.total_cost_emplr = this.total_cost_emplr_calculated;
      },
      immediate: false,
    },
    total_cost_emplr_tax_calculated: {
      handler() {
        this.item.total_cost_emplr_tax = this.total_cost_emplr_tax_calculated;
      },
      immediate: false,
    },
    show_email: {
      handler() {
        if (this.show_email) {
          this.email.attachments = [];
          this.print(true);
        }
      },
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.item.employee_id == null ||
          this.item.employee_id.length == 0
        ) {
          has_errors = true;
          reject("Odabir uposlenika polje je obavezno");
        }
        if (
          this.item.salary_month == null ||
          this.item.salary_month.length == 0
        ) {
          has_errors = true;
          reject("Mjesec polje je obavezno");
        }
        if (
          this.item.salary_year == null ||
          this.item.salary_year.length == 0
        ) {
          has_errors = true;
          reject("Godina polje je obavezno");
        }
        if (this.item.neto === 0 || this.item.neto.length == 0) {
          has_errors = true;
          reject("Neto lični dohodak polje je obavezno");
        }
        if (this.item.neto < 0 || this.item.neto > 999999999999.9999) {
          has_errors = true;
          reject("Neto lični dohodak je izvan dozvoljenih granica");
        }
        if (this.item.meals === 0 || this.item.meals.length == 0) {
          has_errors = true;
          reject("Topli obrok polje je obavezno");
        }
        if (this.item.meals < 0 || this.item.meals > 999999999999.9999) {
          has_errors = true;
          reject("Topli obrok je izvan dozvoljenih granica");
        }
        if (
          this.item.transportation < 0 ||
          this.item.transportation > 999999999999.9999
        ) {
          has_errors = true;
          reject("Naknade za prevoz su izvan dozvoljenih granica");
        }
        if (
          this.item.salary_bonus_other < 0 ||
          this.item.salary_bonus_other > 999999999999.9999
        ) {
          has_errors = true;
          reject("Ostale naknade su izvan dozvoljenih granica");
        }
        if (
          this.item.personal_deduction === 0 ||
          this.item.personal_deduction.length == 0
        ) {
          has_errors = true;
          reject("Lični odbitak polje je obavezno");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on(
        "wp_employee_changed_salary",
        (selected_item) => {
          this.item.employee_id = selected_item.id;
          this.employee_name = selected_item.name;
        }
      );
      this.$webpageEventBus.$on("close_email_dialog", () => {
        this.show_email = false;
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_employee_changed_salary");
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_salary"
      );
    },
    get_item() {
      this.$http({
        method: "POST",
        url: "/salary/get_salary",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        let r_item = resp.data.result[0];
        this.is_loading = false;
        this.item.id = r_item.id;
        this.item.neto = r_item.neto;
        this.item.bruto = r_item.bruto;
        this.item.salary_created = this.$moment(new Date(r_item.salary_created))
          .local()
          .format("YYYY-MM-DD HH:SS");
        this.item.employee_id = r_item.employee_id;
        this.item.salary_year = r_item.salary_year;
        this.item.salary_month = r_item.salary_month;
        this.item.personal_deduction = r_item.personal_deduction;
        this.item.neto_personal = r_item.neto_personal;
        this.item.salary_contribution = r_item.salary_contribution;
        this.item.contribution_to_salary = r_item.contribution_to_salary;
        this.item.net_without_tax = r_item.net_without_tax;
        this.item.salary_tax = r_item.salary_tax;
        this.item.water_contribution = r_item.water_contribution;
        this.item.disaster_contribution = r_item.disaster_contribution;
        this.item.disabled_contribution = r_item.disabled_contribution;
        this.item.meals = r_item.meals;
        this.item.transportation = r_item.transportation;
        this.item.salary_bonus_other = r_item.salary_bonus_other;
        this.item.neto_total = r_item.neto_total;
        this.item.pen_dis_insu = r_item.pen_dis_insu;
        this.item.health_insu = r_item.health_insu;
        this.item.unemp_insu = r_item.unemp_insu;
        this.item.pen_dis_insu_emplr = r_item.pen_dis_insu_emplr;
        this.item.health_insu_emplr = r_item.health_insu_emplr;
        this.item.unemp_insu_emplr = r_item.unemp_insu_emplr;
        this.item.total_cost_emplr = r_item.total_cost_emplr;
        this.item.total_cost_emplr_tax = r_item.total_cost_emplr_tax;
        this.item.neto_total = r_item.neto_total;
      });
    },
    save_salary() {
      this.validate()
        .then(() => {
          this.btn_is_loading = true;
          this.item.account_id = this.$store.getters.user.account_id;
          this.item.salary_created = this.$moment(new Date())
            .local()
            .format("YYYY-MM-DD");
          this.$http({
            method: "POST",
            url: "/salary/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Lični dohodak je ažuriran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_salary");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.btn_is_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
    delete_salary() {
      this.$http({
        method: "POST",
        url: "/salary/delete",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("show_status", {
            type: "success",
            message: "Lični dohodak je obrisan",
            timeout: 2000,
          });
          this.close_dialog();
          this.$webpageEventBus.$emit("reload_data");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: resp.data.message,
            timeout: 4000,
          });
        }
      });
    },
    print(for_email) {
      var logo = this.$store.getters.user.account_logo;
      var document_header = this.$store.getters.user.account_document_header;
      var document_footer = this.$store.getters.user.account_document_footer;
      const doc = new jspdf({
        orientation: "p",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
      });
      var header_start = 5;
      if (logo !== null) {
        var i_width = doc.getImageProperties(logo).width;
        var i_height = doc.getImageProperties(logo).height;
        var i_aspect = i_width / i_height;
        i_width = 11 * i_aspect;
        doc.addImage(logo, "JPEG", 10, 10, i_width, 11);
        header_start += i_width + 10;
      }
      doc.setFont("Roboto-Regular");
      doc.setFontSize(9);
      if (document_header !== null) doc.text(document_header, header_start, 13);

      doc.setFont("Roboto-Regular");
      doc.setFontSize(9);
      if (document_header !== null) doc.text(document_header, header_start, 13);
      doc.text("Mjesto izdavanja dokumenta:", 10, 30);
      doc.text(this.$store.getters.user.account_city, 55, 30);
      doc.text("Datum izdavanja dokumenta:", 10, 35);
      doc.text(
        new Date().toLocaleDateString("sr-Latn-RS", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }),
        55,
        35
      );
      doc.text("Firma:", 100, 30);
      doc.text(this.$store.getters.user.account_name, 120, 30);
      doc.text("Uposlenik:", 100, 35);
      doc.text(this.employee_name, 120, 35);

      doc.autoTable({
        startY: 45,
        tableLineWidth: 0.2,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 11,
          fillColor: [240, 240, 240],
        },
        theme: "plain",
        columnStyles: {
          0: { halign: "center", valign: "middle" },
        },
        margin: { top: 0, left: 10, right: 10 },
        body: [
          {
            text:
              "Specifikacija ličnog dohodka -  " +
              this.employee_name +
              " mjesec " +
              this.months.find((month) => month.value === this.selected_month)
                .text +
              " " +
              this.selected_year +
              "." +
              " god.",
          },
        ],
      });

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        head: [
          [
            {
              content:
                "Lični dohodak (ukupni, neto, bruto) i naknade (topli obrok, prevoz, ostalo)",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Iznos",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
          ],
        ],
        body: [
          [
            {
              content: "Ukupna isplata ličnog dohodka uposleniku",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.neto_total).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Iznos naknade za topli obrok",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.meals).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "iznos naknade za prevoz",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.transportation).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Iznos ostalih naknada",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.salary_bonus_other).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Lični odbitak (sa poreske kartice) u novcu",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.personal_deduction).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Neto lični dohodak",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.neto).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Neto lični dohodak prije oporezivanja",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.net_without_tax).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Porez na lični dohodak",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.salary_tax).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Bruto lični dohodak",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(parseFloat(this.item.bruto).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        head: [
          [
            {
              content: "Doprinosi na teret uposlenika",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Stopa",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Iznos",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
          ],
        ],
        body: [
          [
            {
              content: "Doprinos za penzijsko i invalidsko osiguranje",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "17%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(parseFloat(this.item.pen_dis_insu).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinos za zdravstveno osiguranje",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "12,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(parseFloat(this.item.health_insu).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinos za osiguranje od nezaposlenosti",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "1,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(parseFloat(this.item.unemp_insu).toFixed(2)),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinosi iz bruto plate (na teret uposlenika)",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "31%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.salary_contribution).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        head: [
          [
            {
              content: "Doprinosi na teret poslodavca",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Stopa",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Iznos",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
          ],
        ],
        body: [
          [
            {
              content: "Doprinos za penzijsko i invalidsko osiguranje",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "6%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.pen_dis_insu_emplr).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinos za zdravstveno osiguranje",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "4%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.health_insu_emplr).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinos za osiguranje od nezaposlenosti",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "0,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.unemp_insu_emplr).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Doprinosi iz bruto plate (na teret poslodavca)",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "10,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.contribution_to_salary).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Ukupni trošak za poslodavca",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.total_cost_emplr).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });

      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 5,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        head: [
          [
            {
              content: "Naknade",
              styles: {
                halign: "left",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Stopa",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
            {
              content: "Iznos",
              styles: {
                halign: "center",
                valign: "middle",
                fillColor: [240, 240, 240],
                cellWidth: "wrap",
              },
            },
          ],
        ],
        body: [
          [
            {
              content: "Naknada vodna",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "0,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.water_contribution).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Naknada za zaštitu od nesreća",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "0,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.disaster_contribution).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Naknada za zapošljavanje invalida",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: "0,5%",
              styles: {
                halign: "center",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.disabled_contribution).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 0,
        tableLineWidth: 0.15,
        styles: {
          font: "Roboto-Regular",
          lineWidth: 0.15,
          fontSize: 8.5,
          cellPadding: 1,
        },
        theme: "plain",
        showFoot: "lastPage",
        columnStyles: {
          0: { halign: "center", valign: "top", cellWidth: 10 },
          1: { halign: "left", valign: "top", cellWidth: 30 },
          2: { halign: "left", valign: "top", cellWidth: 30 },
        },
        margin: { top: 10, left: 10, right: 10, bottom: 30 },
        body: [
          [
            {
              content: "Ukupni trošak za poslodavca sa naknadama",
              styles: {
                halign: "left",
                valign: "top",
                cellWidth: "auto",
              },
            },
            {
              content: this.$n(
                parseFloat(this.item.total_cost_emplr_tax).toFixed(2)
              ),
              styles: {
                halign: "right",
              },
            },
          ],
        ],
      });

      doc.setFontSize(8);
      doc.text("___________________________________", 10, 237);
      doc.setFontSize(9);
      doc.text("Potpis uposlenika", 19, 241);
      doc.setFontSize(8);
      doc.text("___________________________________", 82, 237);
      doc.setFontSize(9);
      doc.text("Ovjera računovodstva", 89, 241);
      doc.setFontSize(8);
      doc.text("___________________________________", 155, 237);
      doc.setFontSize(9);
      doc.text("Direktor", 173, 241);

      var numOfPages = doc.internal.getNumberOfPages();
      for (var i = 1; i <= numOfPages; i++) {
        doc.setPage(i);
        var footer_start = 5;
        if (logo !== null) {
          var f_width = doc.getImageProperties(logo).width;
          var f_height = doc.getImageProperties(logo).height;
          var f_aspect = f_width / f_height;
          f_width = 7 * f_aspect;
          doc.addImage(logo, "JPEG", 10, 297 - 18, f_width, 7);
          footer_start += f_width + 10;
        }
        doc.setFontSize(8);
        doc.setTextColor(66, 75, 84);
        if (document_footer !== null)
          doc.text(document_footer, footer_start, 297 - 17);
        QRCode.toDataURL(
          "Specifikacija LD" +
            " " +
            this.employee_name +
            " " +
            this.months.find((month) => month.value === this.selected_month)
              .text +
            " " +
            this.selected_year,
          function(err, url) {
            doc.addImage(url, "png", 210 - 25, 297 - 19, 10, 10);
          }
        );
        doc.text(
          "Stranica " + String(i) + " od " + numOfPages,
          210 - 30,
          297 - 5
        );
        doc.setFontSize(6);
        doc.text(
          "Ovaj dokument je kreiran upotrebom SABIRA™ poslovne platforme. Za više informacija posjetite SABIRA.BA",
          10,
          297 - 5
        );
      }
      if (for_email) {
        var binary = doc.output();
        this.email.subject =
          "Specifikacija ličnog dohodka za" + " " + this.employee_name;
        this.email.sender = {
          name: this.$store.getters.user.name,
          email: this.$store.getters.user.email,
        };
        this.email.attachments.push({
          filename:
            "LD_" +
            this.employee_name +
            "_" +
            this.months.find((month) => month.value === this.selected_month)
              .text +
            "_" +
            this.selected_year +
            ".pdf",
          content: binary,
          encoding: "binary",
        });
        this.email.message =
          "Poštovana/ni, u prilogu se nalazi specifikacija ličnog dohodka za uposlenika " +
          this.employee_name +
          " za" +
          " " +
          "mjesec " +
          this.months.find((month) => month.value === this.selected_month)
            .text +
          "," +
          " " +
          this.selected_year +
          ".god." +
          " " +
          "Za dodatna pitanja stojimo na raspolaganju. Hvala.";
      } else {
        doc.save(
          "LD_" +
            this.employee_name +
            "_" +
            this.months.find((month) => month.value === this.selected_month)
              .text +
            "_" +
            this.selected_year +
            ".pdf"
        );
      }
    },
  },
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
};
</script>
<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}

.card-text-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
}
.container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0px 0px 0px 0px;
}

.salary_info {
  height: calc(90vh - 200px);
  overflow-y: auto;
}

.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
